/**
 * Tarifs v2 (SPEC § 4.6). Route : tarifs.
 *
 * = screens/Prices/index.tsx (v1, non modifié) : même bascule (page administrable si
 * `pricingConfig.enabled`, sinon ancienne page `Services`), même événement GA4 `view_item_list`
 * (liste « Tarifs ») émis dès que la liste des offres est disponible. La page administrable est
 * rendue par sa version v2 (PricingPage) ; l'ancienne page, sans configuration à habiller, reste
 * l'écran v1 dans l'enveloppe v2. Venant d'une fiche cours sans crédit utilisable (état de navigation
 * `classId`), l'ancienne page ne liste que les offres valables pour ce cours, comme la v1 l'affichait
 * dans la fiche (`<Services classId={id} />`).
 */
import { useListServices } from 'hooks/useApiQueries';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Services } from 'screens/Prices/components/Services';
import { trackViewItemList } from 'utils/tracking';
import { classIdFromState } from './lib';
import { PricingPage } from './PricingPage';
import { injectV2Css } from '../../styles/inject';
import pricesCss from './prices.css?inline';

injectV2Css('screens/Prices/prices.css', pricesCss);

export function PricesV2() {
  const useNewPricing = typeof mondayMindbody !== 'undefined' && mondayMindbody?.pricingConfig?.enabled === true;
  // = Class/index.tsx : venant d'une fiche sans crédit utilisable, l'ancienne page Tarifs ne liste que les offres
  // valables pour ce cours (GET sale/services?classId=).
  const classId = classIdFromState(useLocation().state);

  // = Prices v1 : GA4 view_item_list (no-op si le tracking est désactivé ou la liste vide).
  const { data: services } = useListServices();
  useEffect(() => {
    trackViewItemList(services as unknown as Record<string, unknown>[] | undefined, 'Tarifs');
  }, [services]);

  return (
    <div className="mmv2-prices" data-screen="tarifs">
      {useNewPricing ? <PricingPage /> : <Services classId={classId} />}
    </div>
  );
}
